<template>
  <transition name="fade">
    <b-col
      v-show="isReportListVisReportViewer"
      ref="sidebarContainer"
      class="resizable-sidebar"
      :style="{ flex: `0 0 ${sidebarWidth}px`, minWidth: '200px' }"
      @mouseover="onHover('ReportViewer/reportList')"
      @mouseleave="onLeave"
      @mousedown="startResizing"
    >
      <div
        ref="reportList"
        class="reportList px-2 w-100"
      >
        <h6 class="my-3 project-name-header">
          {{ getNameCurrProjectNavigation }}
        </h6>
        <b-row
          class="w-100 m-0 p-0"
          align-h="between"
        >
          <b-col
            cols="auto"
            class="m-0 p-0"
          >
            <b-button
              v-if="isAllowEditNavigation && getCurrentProjectNavigation!==''"
              v-b-tooltip.hover.bottom="'Add Report'"
              size="sm"
              variant="outline-success"
              class="m-0 p-0 btn-add-report"
              @mouseover="onHover('Navigation/addReport')"
              @mouseleave="onLeave"
              @click="addReport"
            >
              <b-icon
                aria-label="Add Value"
                icon="plus-square-fill"
                class="m-0 p-0"
              />
            </b-button>
          </b-col>
          <b-col
            cols="auto"
            class="m-0 p-0"
          >
            <b-button
              v-if="isAllowEditNavigation && getCurrentProjectNavigation!==''"
              v-b-tooltip.hover.bottom="'Refresh'"
              size="sm"
              variant="info"
              class="m-0 p-0"
              @click="refreshReports"
            >
              <b-icon
                aria-label="Add Value"
                icon="arrow-repeat"
                class="m-0 p-0"
              />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col>
            <b-form-input
              v-model="filterText"
              type="text"
              placeholder="Search..."
            />
          </b-col>
        </b-row>
        <p
          v-if="isReportLoading"
          class="message-text-small mt-2"
        >
          <b-spinner
            variant="primary"
            label="Spinning"
            class="spinner-message-small mr-3"
          />Loading reports...
        </p>
        <div
          v-else
          ref="gridWrapper"
          :class="['ag-grid-container', agGridTheme]"
        >
          <ag-grid-vue
            style="width: 100%;"
            :default-col-def="defaultColDef"
            :column-defs="columnReportDefs"
            :row-data="tableItems"
            :grid-options="gridOptions"
            :row-style="rowStyle"
            :get-row-class="getRowClass"
            @grid-ready="onGridReady"
            @rowClicked="rowClick"
          />
        </div>
        <b-button
          v-if="isReportListVisReportViewer"
          size="sm"
          variant="primary"
          class="toggle-reports-showed px-0"
          @click="toggleReportListVisReportViewer"
        >
          <b-icon
            icon="caret-left-fill"
            aria-label="Open Report List"
          />
        </b-button>
      </div>
    </b-col>
  </transition>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { mapGetters, mapActions } from 'vuex'
import ReportInfo from '@/functions/ReportInfo.js'
import { IconIncompleteReport, IconSharing, homogenizeReport } from '@/common/sharedDefinitions/reportDefinitions'

const reNumber=RegExp('\\d+')
const zoneNotify='ReportListSidebar'

export default {
  name:'ReportListSidebar',
  components:{
    AgGridVue,
  },
  data() {
    return{
      isReportLoading:false,
      projectDisplaying:'',
      resizing: false,
      startX: 0,
      startWidth: 0,
      sidebarWidth: 0, // Initial width,
      initialCols: 2,
      minWidth: 200,
      agGridTheme: 'ag-theme-alpine',
      filterText: '',
      tableItems: [],
      rowStyle:{cursor: 'pointer'},
      defaultColDef: {
        editable: false,
        resizable: true,
        filter: false,
      },
      columnReportDefs: [
        { headerName: 'ID', field: 'id', width: 65, maxWidth: 80, sort: 'desc', suppressMovable: true },
        { headerName: 'Report Name', field: 'descriptiveId', minWidth: 80, flex: 1, suppressMovable: true },
      ],
      gridOptions: {
        rowSelection: 'single',
        isRowSelectable: (params) => {
          return params.data.disable !== true;
        },
        suppressRowClickSelection: true, // Rows won't be selected when clicked
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight',
        rowBuffer: 10,
        suppressHorizontalScroll: false,
        suppressNoRowsOverlay: true, // Hide the "No Rows" overlay
        suppressLoadingOverlay: true, // Hide the loading overlay
        rowHeight: 28,
        headerHeight: 30,
      },
    }
  },
  computed: {
    ...mapGetters([
      'isReportListVisReportViewer',
      'getCurrentReportViewer',
      'isForceUpdReprtsTableReportViewer',
      'getDictIdReportsReportViewer',
      'getDictReportsByUIdReportViewer',
      'getReportsProjMiddleware',
      'getNameCurrProjectNavigation',
      'getCurrentProjectNavigation',
      'getCurrentClusterNavigation',
      'getClusterDataMiddleware',
      'isAllowEditNavigation',
      'isReportModifiedReportViewer',
    ]),
  },
  watch:{
    isReportListVisReportViewer(newVal){
      if(newVal){
        this.calculateInitialWidth();
        this.updateTableReports()
      }
    },
    getCurrentReportViewer(newReport) {
      if (!newReport?.id || !this.tableItems.length) return;
      this.tableItems.forEach(row => {
        this.$set(row, 'isActive', row.dbId === newReport.id);
      });
      if (!this._gridApi) return;
      this._gridApi.redrawRows();
      this._goToPageOfReport(newReport.id);
    },
    filterText(newValue) {
      if (this._gridApi) {
        this._gridApi.setQuickFilter(newValue);
      }
    },
  },
  mounted(){
    this.updateTableReports()
    this.calculateInitialWidth();
    window.addEventListener('resize', this.calculateInitialWidth);
    window.addEventListener('resize', this.recalculatePageSize);
  },
  created() {},
  unmounted(){
    window.removeEventListener('resize', this.calculateInitialWidth);
    window.removeEventListener('resize', this.recalculatePageSize);
  },
  methods: {
    ...mapActions([
      'setForceUpdReprtsTableReportViewer',
      'setDictIdReportsReportViewer',
      'setDictReportsByUIdReportViewer',
      'setReportListVisReportViewer',
      'toggleReportListVisReportViewer',
      'readReportsProjMiddleware',
      'setCurrentProjectNavigation',
      'setCurrentClusterNavigation',
      'setContextOnHover',
      'addReportMiddleware',
      'setDragModeReportViewer',
      'setToolSideBarVisibleReportViewer',
      'readClusterListMiddleware',
      'setReportsProjMiddleware',
      'setAllowEditNavigation',
      'setAllowEditReportViewer',
      'setShortIdCurrentReportViewer'
    ]),
    onHover(route) {
      this.setContextOnHover(route)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
    refreshReports(){
      this.setForceUpdReprtsTableReportViewer(true)
      this.updateTableReports()
    },
    async updateTableReports(){
      if(!this.isReportListVisReportViewer){
        return
      }
      const forced = this.isForceUpdReprtsTableReportViewer
      const currentProject=this.$route.params.projectId || this.getCurrentProjectNavigation
      if(currentProject === ''){ //Means nothing is defined
        return
      }
      this.setShortIdCurrentReportViewer('')
      this.isReportLoading = true
      const currentCluster=this.$route.params.clusterId || this.getCurrentClusterNavigation
      try{
        if(forced ||this.getReportsProjMiddleware===null
            ||typeof(this.getCurrentClusterNavigation)==='undefined' ||this.getCurrentClusterNavigation===null|| this.getCurrentClusterNavigation!==currentCluster
            ||typeof(this.getCurrentProjectNavigation)==='undefined' ||this.getCurrentProjectNavigation===null|| this.getCurrentProjectNavigation!==currentProject
        ){
          this.setForceUpdReprtsTableReportViewer(false)
          if (this.getClusterDataMiddleware === null) {
            await this.readClusterListMiddleware()
          }
          const responseData = await this.readReportsProjMiddleware({
            projectId: currentProject,
            clusterId: currentCluster
          })
          if(!responseData.success){
            this.isReportLoading = false
            return
          }
          this.setCurrentProjectNavigation(currentProject)
          this.setCurrentClusterNavigation(currentCluster)
        }
        const disabledProject = this.getReportsProjMiddleware.disable || false;
        if(disabledProject){
          await this.$alert(
            'Exciting Premium content awaits! Please take a moment to verify your subscription',
            'Premium Report',
            'info',
          )
          this.$emit('projectDisabled')
          return;
        }
        const reportsProjArr=this.getReportsProjMiddleware.reports.sort((a,b)=>parseInt(reNumber.exec(a.shortId.toString())[0])>parseInt(reNumber.exec(b.shortId.toString())[0])?-1:1)
        let newDataTable=[]
        this.setDictIdReportsReportViewer({}) //Clean the dictionary of real DB keys
        this.setDictReportsByUIdReportViewer({})
        const activeDbId = this.getCurrentReportViewer?.id || this.$route.params.reportId;
        for(let j=0;j<reportsProjArr.length;j++){
          const isActive = activeDbId === reportsProjArr[j].id;
          reportsProjArr[j].internalCounter = parseInt(reNumber.exec(reportsProjArr[j].shortId.toString())[0])
          if(isActive){
            this.setShortIdCurrentReportViewer(reportsProjArr[j].internalCounter.toString())
          }
          const uncomplete = ReportInfo.isReportUncomplete(this, reportsProjArr[j])
          let reportName = reportsProjArr[j].name
          if(uncomplete){
            reportName = `${IconIncompleteReport}  ${reportName}`
          }
          if(typeof(reportsProjArr[j].shareCount)!=='undefined' && reportsProjArr[j].shareCount > 0){
            reportName = `${IconSharing}  ${reportName}`
          }
          newDataTable.push({
            id: reportsProjArr[j].internalCounter,
            descriptiveId: reportName,
            isActive,
            dbId: reportsProjArr[j].id,
          })
          this.getDictIdReportsReportViewer[reportsProjArr[j].internalCounter]=reportsProjArr[j]
          this.getDictReportsByUIdReportViewer[reportsProjArr[j].id] = reportsProjArr[j]
        }
        this.tableItems = newDataTable;
      }
      catch (e){
        this.setReportListVisReportViewer(false)
        const errTitle='Error loading the reports'
        const errText=`Open Reports sidebar. Message: ${e}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
      finally{
        this.isReportLoading = false
      }
    },
    async rowClick(event){
      const DBReportObject = this.getDictIdReportsReportViewer[event.data.id]
      const idDBReport = DBReportObject.id
      if(idDBReport===this.$route.params.reportId){
        return
      }
      if(this.isReportModifiedReportViewer){
        try{
          await this.$confirm(
            'You have changes to the report without saving. Do you want to discard them?',
            'Discard changes',
            'question',
            {
              confirmButtonText: 'Discard',
            }
          )
        }catch{
          return
        }
      }
      if(typeof(DBReportObject.linkReportId) !== 'undefined' && DBReportObject.linkReportId.length > 0){
        // Linked report opening on a new window
        const routeUrl = this.$router.resolve({ name: 'ReportViewer', params: { 
          projectId: DBReportObject.linkProjectId, 
          reportId: DBReportObject.linkReportId,
          clusterId: DBReportObject.linkClusterId }}).href;
        window.open(routeUrl, '_blank');
        return
      }
      const idDBProj = this.getCurrentProjectNavigation
      const clusterId=this.getCurrentClusterNavigation
      this.setToolSideBarVisibleReportViewer(false)
      const allowEdit = this.isAllowEditNavigation ? true: DBReportObject.allowEdit || false
      this.setAllowEditReportViewer(allowEdit)
      this.$router.push({ name: 'ReportViewer', params: { projectId:idDBProj, reportId: idDBReport,clusterId: clusterId} })
      this.$emit('reportSelected')
    },
    async addReport(){
      if(this.isReportModifiedReportViewer){
        try{
          await this.$confirm(
            'You have changes to the report without saving. Do you want to discard them?',
            'Discard changes',
            'question',
            {
              confirmButtonText: 'Discard',
            }
          )
        }catch{
          return
        }
      }
      this.setForceUpdReprtsTableReportViewer(true);
      try{
        const createReportReq = await this.addReportMiddleware({
          clusterId:this.getCurrentClusterNavigation,
          projectId: this.getCurrentProjectNavigation,
          report_name:`New report ${this.getNameCurrProjectNavigation}`
        });
        if(!createReportReq.success){
          if(createReportReq.code === 403){
            await this.$alert(
              createReportReq.message,
              createReportReq.title || 'Insufficient Permission',
              'info',
            )
          }else{
            const errTitle='Error creating the report'
            const errText='Error connecting with the server. Please try again in a few minutes.'
            this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
          }
          this.isLoading = false
          return
        }
        this.isLoading = false
        const idDBProj = this.getCurrentProjectNavigation
        const clusterId=this.getCurrentClusterNavigation
        this.setDragModeReportViewer(true)
        this.setToolSideBarVisibleReportViewer(false)
        this.setAllowEditReportViewer(true)
				if(!this.getCurrentReportViewer.notHomogenize)
          { homogenizeReport(this,this.getCurrentReportViewer); }
        this.$router.push({ name: 'ReportViewer', params: { projectId:idDBProj, reportId: createReportReq.id,clusterId: clusterId} })
        this.updateTableReports()
        this.$emit('reportSelected')
      }catch(e){
        const errTitle='Error adding new report'
        const errText=`Message: ${e}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }finally{
        this.isReportLoading = false
      }
    },
    startResizing(event) {
      this.resizing = true;
      this.startX = event.clientX;
      this.startWidth = this.sidebarWidth;
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('mouseup', this.stopResizing);
    },
    handleMouseMove(event) {
      if (this.resizing) {
        const deltaX = event.clientX - this.startX;
        this.sidebarWidth = Math.max(this.startWidth + deltaX, 100); // Minimum width
      }
    },
    stopResizing() {
      this.resizing = false;
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('mouseup', this.stopResizing);
    },
    calculateInitialWidth() {
      if(typeof(this.$refs.sidebarContainer) === 'undefined')
        return;
      // Get the width of the container element using the ref
      const containerWidth = this.$refs.sidebarContainer.clientWidth;
      // Get the width of a single column based on the Bootstrap container width
      const columnWidth = containerWidth / 12;
      // Set the initial width based on the number of columns
      this.sidebarWidth = Math.round(this.initialCols * columnWidth);
    },
    getRowClass(params) {
      if (params.data.isActive) return 'active-report-row';
      return params.data.disable ? 'disabled-row' : '';
    },
    recalculatePageSize() {
      const gridWrapper = this.$refs.gridWrapper;
      const reportList = this.$refs.reportList;
      if (!gridWrapper || !reportList || !this._gridApi) return;

      const containerBottom = reportList.getBoundingClientRect().bottom;
      const gridTop = gridWrapper.getBoundingClientRect().top;
      const spaceForGrid = Math.max(0, containerBottom - gridTop);
      const gridHeaderH = this.gridOptions.headerHeight || 30;
      const paginationBarEl = reportList.querySelector('.ag-paging-panel');
      const paginationBarH = paginationBarEl ? paginationBarEl.offsetHeight : 48;
      const availableForRows = spaceForGrid - gridHeaderH - paginationBarH;
      const rowH = this.gridOptions.rowHeight || 28;
      const pageSize = Math.max(3, Math.floor(availableForRows / rowH));

      if (pageSize !== this.gridOptions.paginationPageSize) {
        this.gridOptions.paginationPageSize = pageSize;
        this._gridApi.paginationSetPageSize(pageSize);
        this._gridApi.setRowData(this.tableItems);
      }
    },
    _goToPageOfReport(dbId) {
      let filteredIndex = -1;
      let counter = 0;
      this._gridApi.forEachNodeAfterFilter(node => {
        if (filteredIndex === -1 && node.data.dbId === dbId) {
          filteredIndex = counter;
        }
        counter++;
      });
      if (filteredIndex !== -1) {
        this._gridApi.paginationGoToPage(Math.floor(filteredIndex / this.gridOptions.paginationPageSize));
      }
    },
    onGridReady(params) {
      this._gridApi = params.api;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.recalculatePageSize();
        const activeReport = this.tableItems.find(row => row.isActive);
        if (activeReport) {
          this._goToPageOfReport(activeReport.dbId);
        }
      }));
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-alpine.css';

.ag-grid-container {
  width: 100%;
}

::v-deep .ag-cell {
  font-size: 0.75rem;
  line-height: 28px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}

::v-deep .ag-header-cell-text {
  font-size: 0.75rem;
}

::v-deep .active-report-row {
  background-color: #cce5ff !important;
  border-left: 3px solid #0066cc;
}

.reportList{
  position: absolute;
  top:0;
  left:0;
  background-color: #EEE;
  height: 90vh;
}
.toggle-reports{
  position: absolute;
  top: 0;
  left:0
}
.toggle-reports-showed{
  position: absolute;
  top: 0;
  right:0;
  z-index:99;
}
.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s;
}
.fade-enter,
.fade-leave-to {
  transform: translateX(-15rem);
}
.fade-enter-to,
.fade-leave {
  transform: translateX(0);
}
.message-text-small{
  font-size: 1rem;
  text-align: center;
}
.spinner-message-small{
  height: 1.25rem;
  width: 1.25rem;
}
::v-deep .vue-scroll-view{
  cursor: pointer;
}
.scroll-area{
  position: relative;
  margin: auto;
  width: 100%;
  height: 90%
}
.btn-add-report{
      height: 1.5rem;
}
.project-name-header{
  font-size: 1rem;
  font-weight: bold;
  text-align: left;
}

::v-deep .tools-search {
  margin:0 !important
}
.resizable-sidebar {
  resize: horizontal !important; /* Enable horizontal resizing */
  overflow: auto !important; /* Add scrollbar if content overflows */
  cursor: ew-resize !important; /* Set cursor for resizing */
  transition: width 0.3s ease !important; /* Add a smooth transition effect */
}

</style>